// extracted by mini-css-extract-plugin
module.exports = {"Container":"TogglePill_Container__3T8Wn","Tab":"TogglePill_Tab__3g-xo","Left":"TogglePill_Left__1vLGT","Right":"TogglePill_Right__21CWn","Selected":"TogglePill_Selected__1S1gr"};